module.exports = __webpack_public_path__ + "img/noiseCode.31771551.jpg";